import { makeStyles } from "@material-ui/styles";
import palette from "./palette";

export const useHeaderCellStopListStyles = makeStyles(({ typography }) => ({
  container: {
    padding: `${typography.pxToRem(4)} ${typography.pxToRem(
      0
    )} ${typography.pxToRem(8)} ${typography.pxToRem(10)}`,
  },
  header: {
    color: palette.typography.black.solid,
    fontWeight: "500",
    fontSize: typography.pxToRem(12),
  },
  subheader: {
    color: palette.typography.black.medium,
    fontSize: typography.pxToRem(12),
  },
}));

export const useBodyCellStopListStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    padding: `${typography.pxToRem(6)} ${typography.pxToRem(
      0
    )} ${typography.pxToRem(3)} ${typography.pxToRem(10)}`,
  },
  parcelContainer: {
    justifyContent: "space-between",
  },
  cellText: {
    color: palette.typography.black.solid,
    fontSize: typography.pxToRem(12),
  },
  cellBlue: {
    backgroundColor: palette.statuses.statusBlue,
  },
  cellOrange: {
    backgroundColor: palette.modalButtons.orange,
  },
  cellCroppedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cellTextBold: {
    fontWeight: 600,
  },
  firstIcon: {
    margin: `0 ${typography.pxToRem(10)}`,
  },
  lastIcon: {
    display: "flex",
    alignItems: "center",
  },
  lastIconConsolidatedClass: {
    marginLeft: 0,
    marginRight: typography.pxToRem(6),
  },
  fullHeighContainer: {
    height: "100%",
    display: "flex",
  },
  cellHighValue: {
    width: typography.pxToRem(4),
    height: "100%",
    margin: `${typography.pxToRem(2)} 0`,
  },
}));

export const useHeaderParcelDetailsCellStyles = makeStyles(
  ({ typography }) => ({
    container: {
      padding: `${typography.pxToRem(0)} ${typography.pxToRem(
        0
      )} ${typography.pxToRem(4)} ${typography.pxToRem(14)}`,
    },
    header: {
      color: palette.typography.white.solid,
      fontWeight: "500",
      fontSize: typography.pxToRem(12),
    },
    subheader: {
      color: palette.typography.black.medium,
      fontSize: typography.pxToRem(12),
    },
  })
);

export const useBodyParcelDetailsCellStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    padding: `${typography.pxToRem(4)} ${typography.pxToRem(
      0
    )} ${typography.pxToRem(2)} ${typography.pxToRem(14)}`,
  },
  cellText: {
    color: palette.typography.white.solid,
    fontSize: typography.pxToRem(14),
  },
  cellCroppedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cellYellowText: {
    color: palette.yellow,
  },
  cellTextBold: {
    fontWeight: 600,
  },
  firstIcon: {
    margin: `0 ${typography.pxToRem(10)}`,
  },
  lastIcon: {
    marginLeft: typography.pxToRem(21),
  },
  link: {
    color: palette.typography.white.solid,
  },
  disabled: {
    opacity: 0.38,
    pointerEvents: "none",
  },
  cellBlue: {
    backgroundColor: palette.statuses.statusBlue,
  },
  cellOrange: {
    backgroundColor: palette.modalButtons.orange,
  },
  fullHeighContainer: {
    height: "100%",
    display: "flex",
  },
  cellHighValue: {
    width: typography.pxToRem(4),
    height: "100%",
  },
}));

export const headerCellModalStyles = makeStyles(({ typography }) => ({
  container: {
    padding: `${typography.pxToRem(18)} ${typography.pxToRem(
      0
    )} ${typography.pxToRem(8)} ${typography.pxToRem(14)}`,
    background: palette.stopListHeader,
  },
  header: {
    color: palette.typography.black.solid,
    fontWeight: 500,
    fontSize: typography.pxToRem(12),
  },
}));

export const bodyCellModalStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    padding: `${typography.pxToRem(4)} ${typography.pxToRem(
      0
    )} ${typography.pxToRem(2)} ${typography.pxToRem(14)}`,
  },
  cellText: {
    color: palette.typography.black.solid,
    fontSize: typography.pxToRem(14),
  },
  cellCroppedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cellYellowText: {
    color: palette.yellow,
  },
  cellTextBold: {
    fontWeight: 600,
  },
  firstIcon: {
    margin: `0 ${typography.pxToRem(10)}`,
  },
  lastIcon: {
    marginLeft: typography.pxToRem(21),
  },
  link: {
    color: palette.typography.black.solid,
  },
  cellBlue: {
    backgroundColor: palette.statuses.statusBlue,
  },
  cellOrange: {
    backgroundColor: palette.modalButtons.orange,
  },
  fullHeighContainer: {
    height: "100%",
    display: "flex",
  },
  cellHighValue: {
    width: typography.pxToRem(4),
    height: "100%",
  },
}));
